import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {getTangoCardsTransactions, getTangoCardsTransactionsSuccess, loadDashboardDatas, loadDashboardDatasFailure, loadDashboardDatasSuccess, sendCard, sendCardDatasFailure, sendCardDatasSuccess, sendCards, sendCardsDone, sendCardsSetNbDone} from './tango-cards.actions';
import {catchError, map, mergeMap, switchMap, tap, withLatestFrom} from 'rxjs/operators';
import {of} from 'rxjs';
import {TangoCardsService} from '@app/4dm1n/tango-cards/_store/tango-cards.service';
import {getCurrentExtProfilsState} from '@app/components/projects/ext-profils/store/ext-profils.selector';
import {selectAdminTangoState} from '@app/4dm1n/tango-cards/_store/tango-cards.selectors';

@Injectable()
export class TangoCardsEffects {
  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private tangoCardsService: TangoCardsService,
  ) {
  }

  LinkPublication$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDashboardDatas),
      map((action) => action),

      switchMap((payload) => {
        //
        //
        return this.tangoCardsService.loadTangoDashboardData()
          .pipe(
            map((result) => {
                //
                return loadDashboardDatasSuccess({
                  data: result.data.datas,
                });
                //
              },
            ),
            catchError((e) => of(loadDashboardDatasFailure({error: e}))),
          );
        //
      }),
    ),
  );

  sendCard$ = createEffect(() =>
      this.actions$.pipe(
        ofType(sendCards),
        withLatestFrom(this.store.select(selectAdminTangoState)),
        map((state) => state),
        tap(([payload, state]) => {
          // console.log('Send Cards!');

          state.data.cardsToSend.forEach((aCard) => {
            // console.log('Process ', aCard);

            setTimeout(() => {

              this.store.dispatch(sendCard({
                utid: aCard.utid,
                amount: aCard.amount,
                email: aCard.email,

                subject: aCard.subject,
                message: aCard.message,

              }));

            }, 500);

          });

          //
          //
          //

        }),
      ),
    {dispatch: false});

  sendACard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendCard),
      map((action) => action),
      mergeMap((payload) => {

        //
        //
        return this.tangoCardsService.sendCard(
          payload.utid,

          payload.amount,
          payload.email,

          payload.subject,
          payload.message
        )
          .pipe(
            map((result) => {
                //

                return sendCardDatasSuccess({
                  email: payload.email,
                  data: result,
                });
                //
              },
            ),
            catchError((e) => of(sendCardDatasFailure({email: payload.email, error: e}))),
          );
        //
        //
      }),
    ),
  );

  isFinished$ = createEffect(() =>
      this.actions$.pipe(
        ofType(sendCardDatasSuccess, sendCardDatasFailure),
        withLatestFrom(this.store.select(selectAdminTangoState)),
        map((state) => state),
        tap(([payload, state]) => {
          // console.log('Test if all cards has been sent');
          let carddone = 0;
          state.data.cardsToSend.forEach((aCard) => {
            if (aCard.done) {
              carddone += 1;
            }
          });

          this.store.dispatch(sendCardsSetNbDone({nb: carddone}));
          if (carddone === state.data.cardsToSend.length) {
            this.store.dispatch(sendCardsDone());
          }

        }),
      ),
    {dispatch: false});

  sendCardDone$ = createEffect(() =>
      this.actions$.pipe(
        ofType(sendCardsDone),
        tap((payload) => {
          this.store.dispatch(loadDashboardDatas());
        }),
      ),
    {dispatch: false});

  //
  //
  //
  getTangoCardsTransactions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getTangoCardsTransactions),
      map((action) => action),
      switchMap((payload) => {
        //
        //
        return this.tangoCardsService.getTangoCardsTransactions(payload.emails)
          .pipe(
            map((result) => {
                //
                this.tangoCardsService.setTangoSearchResult(result.data.datas);
                return getTangoCardsTransactionsSuccess({
                  data: result.data,
                });
                //
              },
            ),
            catchError((e) => of(loadDashboardDatasFailure({error: e}))),
          );
        //
      }),
    ),
  );

  //
  //
  //


}
